<template>
  <el-tabs v-model="mainTab" type="card" style="margin: 10px">
    <el-tab-pane label="产地" name="madeIn">
      <el-button-group class="mb10">
        <el-button type="primary" size="small" :plain="typeTab !== 1" @click="typeTab = 1">Pass list</el-button>
        <el-button type="primary" size="small" :plain="typeTab !== 2" @click="typeTab = 2">Block list</el-button>
      </el-button-group>
      <template v-if="typeTab === 1">
        <div>
          <el-select style="width: 400px" v-model="queryForm.keyword" @change="search" placeholder="Select" clearable filterable>
            <el-option v-for="item in madeInStandardList" :key="item.standardMadeInId" :value="item.standardMadeInId" :label="item.name"></el-option>
          </el-select>
        </div>
        <table class="table">
          <tr v-for="(item) in tableData" :key="item.standardMadeInId">
            <td valign="top" width="150">
              <div class="brand-name">{{ item.name }}</div>
            </td>
            <td>
              <el-input v-model="item.boutiqueMadeIn" size="medium" style="width: 200px" @keydown.native.enter="saveMadeInPass(item)" maxlength="128" placeholder="boutique MadeIn"></el-input>
              <div class="tag-group">
                <div class="tag" v-for="(tag, bindex) in item.passArray" :key="bindex">{{ tag.boutiqueMadeIn }}<i @click="removeMadeInPass(item, bindex)" class="el-icon-circle-close"></i></div>
              </div>
            </td>
          </tr>
        </table>
        <el-pagination
          style="text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </template>
      <template v-else>
        <div class="block-list">
          Block MadeIn：<el-input v-model="blockBrandName" size="medium" style="width: 200px" @keydown.native.enter="saveMadeInBlock()" maxlength="128" placeholder="boutique MadeIn"></el-input>
          <div class="tag-group">
            <div class="tag" v-for="(tag, bindex) in blockList" :key="bindex">{{ tag.boutiqueMadeIn }}<i @click="removeMadeInBlock(tag)" class="el-icon-circle-close"></i></div>
          </div>
        </div>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import * as _ from "lodash";
import {
  getMadeInStandardList,
  getMadeInPassList,
  saveMadeInPass,
  removeMadeInPass,
  getMadeInBlockList,
  saveMadeInBlock,
  removeMadeInBlock
} from '../../../api/mapping_cn';

export default {
  data() {
    return {
      mainTab: 'madeIn',
      typeTab: 1, // 1 Pass list 2 Block list
      total: 0,
      queryForm: {
        currentPage: 1,
        pageSize: 25,
        keyword: '',
      },
      tableData: [],
      blockBrandName: '',
      blockList: [],
      madeInStandardList: []
    };
  },
  mounted() {
    this.getMadeInStandardList();
    this.getMadeInPassList();
    this.searchFn = _.debounce(this.getMadeInPassList, 200);
    this.getMadeInBlockList();
  },
  methods: {
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getMadeInPassList();
    },
    handleCurrentChange(currentPage) {
      this.queryForm.currentPage = currentPage;
      this.getMadeInPassList();
    },
    search() {
      this.queryForm.currentPage = 1;
      this.searchFn();
    },
    getMadeInStandardList() {
      getMadeInStandardList().then((res) => {
        if (res.data && res.data.data) {
          this.madeInStandardList = res.data.data;
        }
      })
    },
    getMadeInPassList() {
      getMadeInPassList({
        pageNo: this.queryForm.currentPage,
        pageSize: this.queryForm.pageSize,
        standardMadeInId: this.queryForm.keyword,
      }).then((res) => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    saveMadeInPass(item) {
      if (!item.boutiqueMadeIn) {
        this.$message('请输入内容');
        return;
      }
      saveMadeInPass({
        standardMadeInId: item.standardMadeInId,
        boutiqueMadeIn: item.boutiqueMadeIn,
      }).then(res => {
        if (res.data.success) {
          this.getMadeInPassList();
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
      item.boutiqueBrandName = '';
    },
    removeMadeInPass(item, index) {
      removeMadeInPass({
        apiMadeInMapId: item.passArray[index].apiMadeInMapId,
      }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功');
          this.getMadeInPassList();
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
    getMadeInBlockList() {
      getMadeInBlockList().then(res => {
        if (res.data && res.data.data) {
          this.blockList = res.data.data;
        }
      })
    },
    saveMadeInBlock() {
      if (!this.blockBrandName) {
        this.$message('请输入内容');
        return;
      }
      saveMadeInBlock({
        boutiqueMadeIn: this.blockBrandName,
      }).then(res => {
        console.log(res)
        if (res.data.success) {
          this.getMadeInBlockList();
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
      this.blockBrandName = '';
    },
    removeMadeInBlock(tag) {
      removeMadeInBlock({
        apiMadeInBlockId: tag.apiMadeInBlockId
      }).then(res => {
        if (res.data.success) {
          this.getMadeInBlockList();
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
  },
};
</script>

<style lang="less" scoped>
.mb10 {
  margin-bottom: 10px;
}
.search {
  display: block;
  width: 310px;
}
.table {
  width: 100%;
  margin: 10px 0;
  border-spacing: 0;
  border-collapse: collapse;

  tr{
    border-bottom: 1px solid #ebeef5;

    &:hover {
      background-color: #f5f7fa;
    }
  }
  td {
    padding: 10px;
  }
}
.brand-name {
  margin-top: 8px;
  font-size: 16px;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.tag {
  position: relative;
  margin: 10px 10px 0 0;
  padding: 5px 26px 5px 8px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  i {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 8px 5px;
    margin-top: -16px;
    line-height: 100%;
    cursor: pointer;

    &:hover {
      color: #000;
      font-weight: bold;
    }
  }

  &:hover{
    border-color: #C0C4CC;
  }
}
.block-list {
}
</style>
